import InputTextCP from './InputTextCP'
import InputNumberCP from './InputNumberCP'
import CheckBoxCP from './checkBox/CheckBoxCP'
import MultiselectCP from './MultiselectCP'
import DropdownCP from './DropdownCP'

/*
function makeDisplayType (getDisplay, displayTypesProps = {}) {
  return {getDisplay, displayTypesProps}
})
*/
var DisplayTypes = {}

// COLLECTION and LIST are special types for containing multuple elements, including other lists and collections
DisplayTypes.COLLECTION = {
  id: 'COLLECTION',
  element: null
}
DisplayTypes.LIST = {
  id: 'LIST',
  element: null
}
DisplayTypes.TEXT = {
  id: 'TEXT',
  element: InputTextCP
}
DisplayTypes.NUMBER = {
  id: 'NUMBER',
  element: InputNumberCP
}
DisplayTypes.CHECK_BOX = {
  id: 'CHECK_BOX',
  element: CheckBoxCP
}
DisplayTypes.DROPDOWN = {
  id: 'DROPDOWN',
  element: DropdownCP
}
DisplayTypes.MULTISELECT = {
  id: 'MULTISELECT',
  element: MultiselectCP
}

export default Object.freeze(DisplayTypes)
